import apiClient from './apiClient'

/**
 * Get version of project
 * @returns version number
 */
export const getVersion = () => apiClient.get('/version.json', null, { noCache: true, disableApiURL: true })
